import { useConfig } from '@revenuewell/front-end-bundle';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useEventBus } from '../../../../hooks/use-event-bus';
import { usePatientProfile } from '../../../../hooks/use-patient-profile';
import { useSlideout } from '../../../../hooks/use-slideout';
import { PageRoutes } from '../../../../routing/page-routes';
import { EventPatientProfileWidgetNavigation } from '../../../../types/event-bus';
import SlideOutCard from '../../../shared/slide-out-card';
import { usePatientProfileWidget } from './hooks/use-patient-profile-widget';
import { PatientProfileRouter } from './navigation/router';
import { PatientProfileWidgetWrapper } from './patient-profile-widget.styles';
import { MainViewSkeleton } from './views/main/main.skeleton';

export const PatientProfileWidgetComponent: FC = () => {
  const { config } = useConfig();
  const history = useHistory();
  const { publish } = useEventBus();
  const { patientId } = usePatientProfile();
  const { isLoading, route, goTo } = usePatientProfileWidget();
  const { isVisiblePatient, isVisibleCommunications, hasHistory, back, currentEvent } = useSlideout();

  useEffect(() => {
    if (currentEvent?.messageType === 'patient-profile-widget-navigation') {
      const { data } = currentEvent as EventPatientProfileWidgetNavigation;

      // handle back button click for internal widget navigation
      if (data.route !== route) goTo(data.route, true);
    }
  }, [currentEvent, route]);

  const handleBackClick = () => {
    back();
  };

  const handleClose = () => publish({ messageType: 'closeWidget' });

  const handleExpandClick = () => {
    const goToRoute = `/${PageRoutes.PATIENT_PROFILE}/${patientId}`;

    if (history.location.pathname === goToRoute) {
      handleClose();

      return;
    }

    history.push(goToRoute);
    handleClose();
  };

  return (
    <SlideOutCard
      isVisible={isVisiblePatient || isVisibleCommunications}
      onClose={handleClose}
      onBackClick={hasHistory ? handleBackClick : undefined}
      {...(config.contact.fullPatientProfilePageEnabled === 'true' && patientId && { onExpand: handleExpandClick })}
    >
      <PatientProfileWidgetWrapper>
        {isLoading ? <MainViewSkeleton /> : <PatientProfileRouter />}
      </PatientProfileWidgetWrapper>
    </SlideOutCard>
  );
};
